import { combineReducers } from "redux";
import registerDeviceSlice from "./registerDeviceReducer";
import deviceConfigSlice from "./deviceConfigReducer";
import dynamicStyleSlice from "./dynamicStyleSheetReducer";
import guestRequestSlice from "./guestRequestReducer";
import guestBillDetailsSlice from "./viewBillReducer";
import serverDateTimeSlice from "./serverDateTimeReducer";
import hotelLangSlice from "./hotelLangReducer";
import hotelSelectorSlice from "./hotelSelectorReducer";
import appConfigSlice from "./appConfigReducer";
import appPreservedConfigSlice from "./appPreservedConfigReducer";
import translationSlice from "./translationReducer";
import guestDetailsSlice from "./guestDetailsReducer";
import storeInfoSlice from "./hcommerceReducer";
import tableReservationSlice from "./tableReservationReducer";
import checkInSlice from "./checkInReducer";
import notificationSlice from "./notificationReducer";
import documentListSlice from "./documentListReducer";
import countryListSlice from "./countryListReducer";
import doorKeySlice from "./doorKeyReducer";
import guestItinerarySlice from "./guestItineraryReducer";
import guestRoomSlice from "./guestRoomReducer"
import deeplinkSlice from "./deeplinkReducer";

const rootReducer = combineReducers({
    registerDeviceSlice,
    dynamicStyleSlice,
    deviceConfigSlice,
    guestRequestSlice,
    guestBillDetailsSlice,
    serverDateTimeSlice,
    hotelLangSlice,
    hotelSelectorSlice,
    appConfigSlice,
    appPreservedConfigSlice,
    translationSlice,
    guestDetailsSlice,
    storeInfoSlice,
    tableReservationSlice,
    checkInSlice,
    notificationSlice,
    documentListSlice,
    countryListSlice,
    doorKeySlice,
    guestItinerarySlice,
    guestRoomSlice,
    deeplinkSlice
})

export default rootReducer